module.exports = __webpack_public_path__ + "img/conduktor.54ddab2a.png";